import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Users } from "lucide-react";
import { G, errMsg } from "./guestApi";

export function AudiencePreview({ session, centres }) {
  const [picked, setPicked] = useState([]);
  const [optedInOnly, setOptedInOnly] = useState(true);
  const [res, setRes] = useState(null);
  const toggle = (c) => setPicked((p) => (p.includes(c) ? p.filter((x) => x !== c) : [...p, c]));
  const run = async () => {
    try {
      const r = await api.post(`${G}/audience/preview`, { token: session.token, centers: picked,
        consent: optedInOnly ? "OPTED_IN" : "ANY" });
      setRes(r.data);
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Card data-testid="guest-audience-preview">
      <CardHeader><CardTitle className="text-sm flex items-center gap-2"><Users className="w-4 h-4" />
        Combined audience check (counts only)</CardTitle></CardHeader>
      <CardContent className="space-y-2 text-sm">
        <div className="flex flex-wrap gap-1 max-h-24 overflow-auto">
          {centres.map((c) => (
            <Button key={c.code} size="sm" className="h-7" variant={picked.includes(c.code) ? "default" : "outline"}
              onClick={() => toggle(c.code)} data-testid={`guest-audience-centre-${c.code}`}>{c.code}</Button>))}
        </div>
        <label className="flex items-center gap-2 text-xs">
          <input type="checkbox" checked={optedInOnly} onChange={(e) => setOptedInOnly(e.target.checked)}
            data-testid="guest-audience-optedin" /> Opted-in guests only
        </label>
        <Button size="sm" onClick={run} disabled={picked.length === 0} data-testid="guest-audience-run">Count recipients</Button>
        {res && (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-xs" data-testid="guest-audience-result">
            <div className="border rounded p-2"><div className="text-slate-500">Guest records</div><div className="text-lg font-semibold">{res.total_records}</div></div>
            <div className="border rounded p-2"><div className="text-slate-500">In more than one centre</div><div className="text-lg font-semibold">{res.shared_across_selected_centres}</div></div>
            <div className="border rounded p-2"><div className="text-slate-500">Excluded (opted out)</div><div className="text-lg font-semibold">{res.excluded_opted_out}</div></div>
            <div className="border rounded p-2 border-emerald-300"><div className="text-slate-500">Unique recipients</div>
              <div className="text-lg font-semibold" data-testid="guest-audience-unique">{res.unique_eligible_recipients}</div></div>
            <div className="col-span-full text-slate-500 italic">{res.note}</div>
          </div>)}
      </CardContent>
    </Card>
  );
}
